import React from 'react';
import {theme} from 'antd';

interface ReFulfillAdditionaDataRowProps {
  data: any;
  buttonJSX?: JSX.Element;
  sentToAddressMarkUp?: JSX.Element;
  isSecondRow?: boolean;
}

const ReFulfillAdditionaDataRow = (props: ReFulfillAdditionaDataRowProps) => {
  const {token}: any = theme.useToken();
  const cellStyle: React.CSSProperties = {border: `1px solid ${token.colorSecondary}`, padding: 8};

  return (
    <table aria-label="history" style={{width: '100%', borderCollapse: 'collapse'}}>
      <thead>
        <tr>
          <th style={{...cellStyle, textAlign: 'left'}}>{!props.isSecondRow && 'Sent to'}</th>
          <th style={{...cellStyle, minWidth: 90, textAlign: 'left'}}>SR date</th>
          <th style={{...cellStyle, textAlign: 'left'}}>SR number</th>
          <th style={{...cellStyle, textAlign: 'left'}}>SR status</th>
          <th style={{...cellStyle, textAlign: 'left'}}>Reason for Re-Fulfill</th>
          <th style={{...cellStyle, textAlign: 'left'}}>Additional Comments</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td
            style={{
              ...cellStyle,
              lineHeight: '12px',
              maxWidth: 160,
              width: 160,
            }}>
            <span
              style={{
                textOverflow: 'word-wrap',
                overflowWrap: 'break-word',
                lineHeight: '12px',
              }}>
              {!props.isSecondRow && props.data.sentToEmail}
            </span>
            {!props.isSecondRow && props.sentToAddressMarkUp}
          </td>

          <td style={{...cellStyle, width: 100}}>
            <span style={{whiteSpace: 'pre-line'}}>{props.data.srDate}</span>
          </td>
          <td style={{...cellStyle, width: 120}}>{props.data.srNumber}</td>
          <td style={{...cellStyle, width: 80}}>{props.data.srStatus}</td>
          <td style={{...cellStyle, width: 80}}>{props.data.reason}</td>
          <td style={cellStyle}>{props.data.additionalComments}</td>
          <td style={{...cellStyle, textAlign: 'right', width: 160}}>{props.buttonJSX}</td>
        </tr>
      </tbody>
    </table>
  );
};

export default ReFulfillAdditionaDataRow;
